export enum ApiVariableValueReason {
  EMISSION = 'EMISSION',
  ENERGY = 'ENERGY',
}

export enum ParameterValueReason {
  Energy = 'energy',
  Emission = 'emission',
  InventoryImport = 'inventory_import',
}

export type ParameterValueReasonType = 'emission' | 'energy' | 'inventory_import' | null;
